/* eslint-disable no-useless-escape */
enum RegexFieldTypes {
  'EMAIL' = 'email',
  'PHONE' = 'phone',
  'GST' = 'gst',
  'PAN' = 'pan',
  'BANK' = 'bank',
  'AUTH_CLIENT_ID' = 'auth_client_id',
  'AMOUNT' = 'amount',
  'DATE' = 'date',
  'AGE' = 'age',
  'ELEMENT_NAME' = 'element_name',
  'USER_NAME' = 'user_name',
  'PARTNER_NAME' = 'partner_name',
  'ACTIVITY_CODES' = 'activity_codes',
  'ADDITIONAL_FIELD_ENUMS' = 'additional_field_enums',
  'COHORT_NAME' = 'cohort_name',
  'FIELDMAPPING_NAME' = 'fieldmapping_name',
  'SLAB_VALUE' = 'slab_value',
  'ITEM_CONDITION_VAL' = 'item_condition_val',
  'WEBHOOK_URL' = 'webhook_url',
  'NO_SPACE_ON_BEGINNING_END' = 'no_space_on_beginning_end',
  'MOPS_TO_EXCLUDE' = 'mops_to_exclude',
  'REFERENCE_NUMBER' = 'reference_number',
  'AMOUNT_WITH_TWO_DECIMAL_PLACES' = 'amount_with_two_decimal_places',
  'TIER_NAME' = 'tier_name',
  'SUBSCRIPTION_PLAN_NAME' = 'subscriptionPlan_name',
  'ADDIONAL_FIELD_INPUT' = 'addtional_field_input',
  'CURRENCY_UNIT_INPUT' = 'currency_unit_input',
  'ALPHANUMERIC' = 'alphanumeric',
  'ADDITIONAL_FIELD' = 'additional_field',
  'RULE_ERROR_MESSAGE' = 'rule_error_message',
  'CHANNEL_ID' = 'channel_id',
  'SAFE_SEARCH_INPUT' = 'safe_search_input'
}

type ValidationRegex = {
  [key in RegexFieldTypes]: RegExp;
};

export const regexConstants: ValidationRegex = {
  [RegexFieldTypes.EMAIL]: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  [RegexFieldTypes.PHONE]: /^[1-9]{1}[0-9]{9}$/,
  [RegexFieldTypes.GST]:
    /^([0][1-9]|[1-2][0-9]|[3][0-8])[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}/,
  [RegexFieldTypes.PAN]: /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/,
  [RegexFieldTypes.BANK]: /^\d{9,18}$/,
  [RegexFieldTypes.AUTH_CLIENT_ID]: /^[a-z0-9_-]*$/,
  [RegexFieldTypes.ADDITIONAL_FIELD_ENUMS]: /^[a-z0-9_,-]*$/,
  [RegexFieldTypes.ACTIVITY_CODES]: /^(?!-)[a-z0-9_-]+$/,
  [RegexFieldTypes.ADDITIONAL_FIELD]: /^(?!-)[a-z0-9_-]+$/,
  [RegexFieldTypes.AMOUNT]: /^[0-9]*$/,
  [RegexFieldTypes.DATE]: /^([1-9]|[12][0-9]|3[01])$/,
  [RegexFieldTypes.AGE]: /^(0|[1-9][0-9]?|1[0-9]{2}|200)$/,
  [RegexFieldTypes.ELEMENT_NAME]: /^[a-zA-Z0-9\s]+/,
  [RegexFieldTypes.USER_NAME]: /^[a-zA-Z ]*$/,
  [RegexFieldTypes.PARTNER_NAME]: /^[a-zA-Z0-9- ]*$/,
  [RegexFieldTypes.COHORT_NAME]:
    /^(?!.* {2})[a-zA-Z0-9]([a-zA-Z0-9 _-]*[a-zA-Z0-9])?$/,
  [RegexFieldTypes.FIELDMAPPING_NAME]: /^[a-zA-Z0-9 ]*$/,
  [RegexFieldTypes.SLAB_VALUE]: /^[0-9][1-9]*(.?[0-9]{1,2}$)?$/,
  [RegexFieldTypes.ITEM_CONDITION_VAL]: /^[a-z0-9_,-]*$/,
  // ISR-fix: require https and block < > \ to prevent injection
  [RegexFieldTypes.WEBHOOK_URL]: /^https:\/\/[^\s<>\\]*$/,
  [RegexFieldTypes.NO_SPACE_ON_BEGINNING_END]: /^(?! ).*[^ ]$/,
  // ISR-fix: removed < > % which are injection-risk characters
  [RegexFieldTypes.MOPS_TO_EXCLUDE]: /^[a-zA-Z0-9_,-~!#$^&*()+={}[\]|;:',.?]*$/,
  // ISR-fix: fixed A-z→A-Za-z range; removed < > % / \ injection-risk chars
  [RegexFieldTypes.REFERENCE_NUMBER]:
    /^[A-Za-z\d_@.#$=!^)(\]:\*;\?,}{'\|&\+-]*$/,
  [RegexFieldTypes.AMOUNT_WITH_TWO_DECIMAL_PLACES]: /^\d+(\.\d{1,2})?$/,
  [RegexFieldTypes.TIER_NAME]: /^[a-zA-Z0-9_\-]+(?: [a-zA-Z0-9_\-]+)*$/,
  [RegexFieldTypes.SUBSCRIPTION_PLAN_NAME]: /^[a-zA-Z0-9 _-]*$/,
  [RegexFieldTypes.ADDIONAL_FIELD_INPUT]: /^.{0,100}$/,
  [RegexFieldTypes.CURRENCY_UNIT_INPUT]: /^[A-Za-z][A-Za-z\s]*[A-Za-z]$/,
  [RegexFieldTypes.ALPHANUMERIC]: /^[a-zA-Z0-9]+$/,
  [RegexFieldTypes.RULE_ERROR_MESSAGE]: /^(?! )[a-zA-Z0-9,:\- ]*(?<! )$/,
  [RegexFieldTypes.CHANNEL_ID]: /^[a-zA-Z0-9_-]+$/,
  // ISR FND-2565627: block < > % / \ in all free-text search inputs
  [RegexFieldTypes.SAFE_SEARCH_INPUT]: /^[^<>%/\\]*$/
};
